// componnents/UI/EmptyState.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Package, ShoppingBag, MapPin, Heart, Search, Store, MessageCircle, Inbox } from 'lucide-react';
import './UI.css';

const icons = {
  package: Package,
  cart: ShoppingBag,
  location: MapPin,
  wishlist: Heart,
  search: Search,
  store: Store,
  messages: MessageCircle,
  inbox: Inbox,
};

const EmptyState = ({ 
  icon = 'package',
  title = 'Nothing here yet',
  description = '',
  actionText = '',
  actionLink = '/',
  onAction = null,
  variant = 'section',
}) => {
  const IconComponent = icons[icon] || Package;
  const className = [
    'empty-state',
    variant === 'fullPage' ? 'empty-state--full-page' : '',
    variant === 'inline' ? 'empty-state--inline' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <IconComponent size={64} strokeWidth={1} className="empty-icon" />
      <h3 className="empty-title">{title}</h3>
      {description && <p className="empty-description">{description}</p>}
      {actionText && (
        onAction ? (
          <button className="empty-action-btn" onClick={onAction}>
            {actionText}
          </button>
        ) : (
          <Link to={actionLink} className="empty-action-btn">
            {actionText}
          </Link>
        )
      )}
    </div>
  );
};

export default EmptyState;

